export default {
  update: {
    method: 'post',
    url: '/admincp/setting/toll-stations'
  },
  get: {
    method: 'get',
    url: '/admincp/setting/toll-stations'
  }
}
